import { ExportPreference } from './export-preference';
import { ConnectionListFilters } from './connection-list-filters';

export class UserCompanyPreference {
    id: string;
    name: string;
    avatar_url: string;
    locationId: string;
    previousLocationId: string;
    isMultiLocation: boolean;
    isDeliveryOrdersSeen: boolean;
    unitMeasurement: string;
    connectionList: ConnectionListFilters;
    export: ExportPreference;
    trialExpiredReminder: boolean;
}
